<template>
  <div :class="isPureText ? 'person-wrap-read' : 'person-wrap'">
    <!-- 人员纯文本 -->
    <read-personnel v-if='isPureText' v-bind='{...$props, personList}'></read-personnel>
    <template v-else>
      <sy-select
        v-model="itemKey"
        v-bind="{...$props, ...$attrs}"
        v-on="$listeners"
        :disabled="disabled"
        :remoteMethod="_getPersonList"
        :placeholder="placeholder"
        :filterPlaceholder="placeholder"
        :multiple="multiple"
        @change="selectChange"
        filterable
      >
        <sy-option
          v-for="item in personList"
          :key="item[key]"
          :label="selectLabel(item)"
          :value="item[key]"
        />
      </sy-select>
    </template>
  </div>
</template>

<script>
  import Api from './api.js'
  import SySelect from '../../../../../basis/select'
  import SyOption from '../../../../../basis/option'
  import ReadPersonnel from './read-personnel.vue'
  import cachedRequest from '../../../../../../utils/cached-request'
  import projectInfo from '../../../utils/project-info'
  import {personnelProps} from './index.js'
  import getUserInfo from '../../../utils/user-info'
  // 采供和供应商各段的接口
  const apiMap = {
    'pur': {
      userList: Api.userList,
      getPerson: Api.getPersonById
    },
    'sur': {
      userList: Api.supplierUserList,
      getPerson: Api.supplierGetById
    },
    'mall': {
      userList: Api.userList,
      getPerson: Api.getPersonById
    }
  }

  export default {
    name: 'personnel',
    components: {
      SySelect,
      SyOption,
      ReadPersonnel
    },
    data () {
      return {
        itemKey: '',
        personList: [],
        allPersonList: []
      }
    },
    model: {
      prop: 'select',
      event: 'select-change'
    },
    props: personnelProps,
    watch: {
      select: {
        immediate: true,
        deep: true,
        async handler (val) {
          const type = Object.prototype.toString.call(val)
          const key = this.key
          const typeMap = {
            '[object Array]': () => {
              return val.map(v => {
                if (!this.valueKey) {
                  return v[key]
                }
                return v
              })
            },
            default: async () => {
              const personItem = await this.getPersonDetail(val)
              return personItem[key]
            },
          }

          this.itemKey = await (typeMap[type] || typeMap['default'])()
        }
      }
    },
    created () {
      if (this.currentUser) {
        this._getLoginUser()
      }
    },
    computed: {
      key () {
        return this.valueKey || 'id'
      },
      project () {
        return projectInfo.query() || ''
      },
      userApi () {
        return apiMap[this.project]
      }
    },
    methods: {
      selectLabel ({code, name}) {
        return projectInfo.include('sur')
          ? name
          : name + (code || '')
      },
      async transferValue (val) {
        const valueKey = this.valueKey
        if (!val) {
          this.allPersonList = []
          this.personList = []
          return valueKey ? '' : {_update: true}
        }

        const type = Object.prototype.toString.call(val)
        const valueTypeHandle = async () => {
          if (!valueKey) {
            const item = await this.getPersonDetail(val)
            return {
              ...item,
              _update: true
            }
          }
          return val
        }
        const typeMap = {
          '[object Array]': async () => {
            const arr = []
            for (let v of val) {
              if (!valueKey) {
                const item = await this.getPersonDetail(v)
                arr.push({
                  ...item,
                  _update: true
                })
              }
              arr.push(v)
            }
            return arr
          },
          '[object String]': valueTypeHandle,
          '[object Number]': valueTypeHandle
        }
        return typeMap[type]()
      },
      async selectChange (val) {
        this.$emit('select-change', await this.transferValue(val))
        this.$emit('validateField')
      },
      async getPersonDetail (data) {
        const type = Object.prototype.toString.call(data)
        const isObj = type === '[object Object]'
        // 人员id
        let id = isObj ? data?.id : data

        if (!data || !id) return {}

        return new Promise(async resolve => {
          const item = this.allPersonList.find(v => Number(id) === v['id'])

          if (item) {
            return resolve(item)
          }

          if (isObj && data?.name) {
            this.allPersonList = [
              ...this.allPersonList,
              data
            ]
            this.personList = [
              ...this.personList,
              data
            ]
            return resolve(data)
          }

          const api = this.userApi.getPerson
          const res = await cachedRequest(api, {id})

          if (res.isOk && res.content) {
            this.allPersonList = [
              ...this.allPersonList,
              res.content
            ]
            this.personList = [
              ...this.personList,
              res.content
            ]
            return resolve(res.content)
          }
          resolve({})
        })
      },
      // 获取用户列表
      async _getPersonList (query, size = 100) {
        if (!query) {
          this.personList = []
          return
        }

        const api = this.userApi.userList
        // 临时
        // api.url = '/pur/apaas/person/getListByName'
        let params = Object.assign({}, {page: 1, pageSize: size}, {name: query}, this.defaultParams)
        const res = await cachedRequest(api, params)
        if (res.isOk) {
          // 缓存搜索的数据
          this.allPersonList = [...(res.content || [])]
          this.personList = [...(res.content || [])]
        }
      },
      // 获取用户列表
      async _getLoginUser () {
        const loginUser = getUserInfo()
        this.personList = [loginUser]
        this.$emit('select-change', {...loginUser, _update: true})
      }
    }
  }
</script>

<style scoped lang="scss">
  .person-wrap {
    min-width: 100px;

    .el-select .el-select--small, .sy-select {
      width: 100%;
      display: inline-block;
      vertical-align: top;
      ::v-deep .el-input__suffix {
        line-height: 32px;
      }
      ::v-deep .sy-magic-input--mini .el-input__suffix{
        line-height: 28px;
      }
    }

    .el-select.el-select--mini {
      width: 100%;
    }
  }
</style>
